import React, { useEffect } from "react";
import Navigation from "../Components/Navigation/Navigation";
import "../Pages/ProcessRent.css";
import Footer from "../Components/Navigation/Footer";
import Banner from "../Components/Banner";
import Building from "../Assets/Images/Homepage/stock-birken.jpg";
import Trees from "../Assets/Images/Homepage/gonzalo-facello.jpg";
import BannerPic from "../Assets/Images/Banner/process-lettings.jpg";

function ProcessRent() {
  useEffect(() => {
    document.title = "Rent Process | Zen Homes";
  }, []);

  return (
    <div className="processRentContainer">
    <Navigation linkColor="black" submenuColor="black" menuIconColor="black"/>
      <Banner title="Process of Renting" backgroundImage={BannerPic} />
      <div className="processLayoutContainer">
        <div className="processInfo">
          <p>
            Our process is very straight forward, and some simple steps and
            stages of lettings are below for you to follow securing a property
            through Zen Homes.
          </p>
          <div className="process">
            <ol>
              <li>
                Once you have viewed the property through us and would like to
                secure it, we will require a holding deposit of one week’s rent
                paid immediately so that we can take the property off the market
                (subject to your offer being accepted by the landlord) If we do
                have multiple offers at the same price, we would require for you
                to place your best and final offer and subject to landlord
                acceptance we can move forward in the same way.
              </li>
              <br />

              <li>
                Upon receipt of the holding deposit, we will send you over the
                payment breakdown and require you to complete our tenancy
                application form along with the supporting documents below that
                we need to process your application:
                <br />
                <br />
                <ul className="listInfo">
                  <li>Last 3 Months Bank Statement’s</li>
                  <br />
                  <li>Last 3 Months Payslip’s</li>
                  <br />
                  <li>Photo ID Passport/Driving License</li>
                  <br />
                  <li>Current/Previous Landlord Reference</li>
                  <br />
                  <li>Employment Reference</li>
                  <br />
                </ul>
              </li>
              <li>
                Once all the above has been received we shall submit the
                reference and credit checks (which normally take up to 48 hours
                to come back)
              </li>
              <br />
              <li>
                Upon receiving satisfactory checks from our reference company,
                that will complete the process and for you to be a qualified
                tenant.
              </li>
              <br />
              <li>
                We will then draft the contract in readiness for you to sign and
                finalise the move into the property and carry out the check in
                inventory/pictures.
              </li>
              <br />
              <li>
                Just before we hand over the keys, we will require you to
                transfer the remaining funds into our account and you’re all
                set.
              </li>
              <br />
              <li>
                Lastly, we will send you all relevant certificates, how to rent
                guide, register your security deposit in a protection scheme and
                send you the prescribed information form for signing.
              </li>
              <br />
            </ol>
          </div>

          <p>
            If you do have any further questions related to the lettings process
            above, please do not hesitate to contact us{" "}
          </p>
        
        </div>
        <div className="stackedContainer">
          <img className="stackedOne" src={Building} alt="Scott Birken" />
          <img className="stackedTwo" src={Trees} alt="Gonzalo Facello" />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ProcessRent;
